export type PromptInsertContext = {
  before: string;
  after: string;
};

export function buildMessageWithPrompt(
  { before, after }: PromptInsertContext,
  promptBody: string
): string {
  const spacer = after.startsWith(' ') || after === '' ? '' : ' ';
  return `${before}${promptBody}${spacer}${after}`;
}

export function getCursorAfterPromptInsert(
  { before, after }: PromptInsertContext,
  promptBody: string
): number {
  const spacer = after.startsWith(' ') || after === '' ? '' : ' ';
  return before.length + promptBody.length + spacer.length;
}
